import type { FC } from 'react';
import type { DateTimeSectionProps } from '../../types';
import DateTimeGroup from './DateTimeGroup';

const DateTimeSection: FC<DateTimeSectionProps> = ({ formData, onInputChange, error }) => {
  return (
    <div className="schedule-meeting-modal__form-group">
      <div className="schedule-meeting-modal__input-group">
        <div className="schedule-meeting-modal__input-label">Date & time *</div>
        <div className="schedule-meeting-modal__datetime-container">
          <DateTimeGroup
            dateValue={formData.fromDate}
            timeValue={formData.fromTime}
            onDateChange={(val) => onInputChange('fromDate', val)}
            onTimeChange={(val) => onInputChange('fromTime', val)}
          />

          <span className="schedule-meeting-modal__datetime-separator">to</span>

          <DateTimeGroup
            dateValue={formData.toDate}
            timeValue={formData.toTime}
            onDateChange={(val) => onInputChange('toDate', val)}
            onTimeChange={(val) => onInputChange('toTime', val)}
          />
        </div>
        {error && <span className="schedule-meeting-modal__error-message">{error}</span>}
      </div>
    </div>
  );
};

export default DateTimeSection;
